import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./DispositionWhatsappTemplates.module.css";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WhatsappMessagePreview from "../WhatsappMessagePreview/WhatsappMessagePreview";
import { whatsappSetupDispositionTabs, whatsappSetupMakretingTabs } from "../../mockData";
import { TabContent, TabNavItem } from "../../TabLayout/TabLayout";
import DispositionWhatsappTemplate1 from "./DispositionWhatsappTemplate1";
import DispositionWhatsappTemplate2 from "./DispositionWhatsappTemplate2";
import { fetchDispositionTemplates } from "../../../Services/marketingAutomation";
import ToggleButton from "../../../Components/ToggleButton/ToggleButton";
import { v4 as uuidv4 } from 'uuid';
import { createOrgDispositionConfig, updateOrgDispositionConfig } from "../../../Services/marketingAutomation";
import { useHistory } from "react-router-dom";
import { fetchOrgDispositionSetupConfig } from "../../../Services/organizations";
import PaginationFooter from "../../PaginationFooter/PaginationFooter";

type props = {
    templatesDirection?: any
    selectedTemplatesType?: any
    orgConfigTemplates?: any
    organizationId: string
    screen?: string
    constants?: any
};

const DispositionWhatsappTemplates: FunctionComponent<props> = ({ templatesDirection, selectedTemplatesType, orgConfigTemplates, organizationId,screen, constants }) => {
    const [activeTab, setActiveTab] = useState<string | number>("Call Back");
    const dispatcher = useDispatch();
    const [selectedSubDisposition, setSelectedSubDisposition] = useState("");
    const [selectedContact, setSelectedContact] = useState<string | number>("30");
    const [dispositionTemplates, setDispositionTemplates]: any = useState([]);
    const [selectedTemplateMap, setSelectedTemplateMap]:any = useState({});
    const [activeDispositionMap, setActiveDispositionMap]:any = useState({});
    const [saveTemplateConfig, setSaveTemplateConfig]:any = useState([]);
    const [orgDispositionSetupConfig, setOrgDispositionSetupConfig]:any = useState([]);
    const [showSubmitButton, setShowSubmitButton]:any = useState(false);
    const history = useHistory();
    const [showDownload, setShowDownload] = useState<string | number | null>(null);
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(5);
    const [totalCount, setTotalCount] = useState<number>(0);
    const isLastPage = page * pageSize >= totalCount;
    // useEffect(()=>{
    //     console.log("akalakla bb",saveTemplateConfig)
    // },[saveTemplateConfig])
    // const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setSelectedContact(e.target.value);
    // };

    const replacePlaceholders = (msgContent: string, placeholderHeaders: string | null) => {
        // Sample values map with the actual values
        let sampleValuesMap = constants.whatsappSampleValuesMap;
    
        // Default placeholder headers if the provided headers are null or empty
        const defaultHeaders = "customer_name~callback_link~agent_page_link~agent_name~company_name";
    
        // Use the provided headers or fallback to the default ones
        const headers = (placeholderHeaders && placeholderHeaders.trim()) ? placeholderHeaders.split('~') : defaultHeaders.split('~');
    
        // Use a regular expression to match placeholders like {{1}}, {{2}}, etc.
        const updatedMsgContent = msgContent.replace(/{{(\d+)}}/g, (match, index) => {
            // Adjust index to be zero-based
            const headerIndex = parseInt(index, 10) - 1;
    
            // Get the corresponding header name (e.g., 'customer_name' from headers)
            const headerName = headers[headerIndex];
    
            // Check if the header name exists in the sampleValuesMap
            if (headerName && sampleValuesMap && sampleValuesMap[headerName]) {
                return sampleValuesMap[headerName]; // Replace with value from sampleValuesMap
            }
    
            // If header name is not found in sampleValuesMap, return the original placeholder
            return match;
        });
    
        return updatedMsgContent;
    };
      

    const subDispositionMap: Record<string, string> = {
        "Call Back": "Not Picked",
        "Interested": "Call Back",
        "Not Interested": "Low Budget",
        "Won": "Won",
        "Lost": "Better Deal/Already Purchased",
        "Pre Launch": "Teaser Message",
        "Offers": "Personalized Festive Greeting with Offer",
        "Genric": "General Introduction with Emphasis on Expertise",
    };

    useEffect(() => {
        fetchOrgDispositionSetupConfig(organizationId,setOrgDispositionSetupConfig);
    }, [])

    useEffect(()=>{
        if(screen === "Setup Templates" && orgDispositionSetupConfig.length > 0){
            let tempSelectedObj: any = {};
            let tempSaveTemplateConfig: any = [];
            let tempActiveDispositionObj: any = {};

            orgDispositionSetupConfig.map((item: any) => {
                tempSelectedObj[item.SUB_DISPOSITION] = item.WATID
                tempSaveTemplateConfig.push({
                    "ORGANIZATION_ID": item.ORGANIZATION_ID,
                    "WATID": item.WATID,
                    "DISPOSITION": item.DISPOSITION,
                    "SUB_DISPOSITION": item.SUB_DISPOSITION,
                    "ISACTIVE": item.ISACTIVE
                })
                tempActiveDispositionObj[item.SUB_DISPOSITION] = item.ISACTIVE == "Y" ? true : false;
            })

            setSelectedTemplateMap(tempSelectedObj);
            setSaveTemplateConfig(tempSaveTemplateConfig);
            setActiveDispositionMap(tempActiveDispositionObj);
            setShowSubmitButton(true);
        }
    },[orgDispositionSetupConfig])
    
    useEffect(() => {
        // setPage(1);
        // Find the corresponding sub disposition for the activeTab
        const disposition = subDispositionMap[activeTab];
        if (disposition) {
            setSelectedSubDisposition(disposition);
        }
    }, [activeTab]);

    useEffect(() => {

        if (orgConfigTemplates && orgConfigTemplates.length > 0) {
            let tempSelectedObj: any = {};
            let tempSaveTemplateConfig: any = [];
            let tempActiveDispositionObj: any = {};

            orgConfigTemplates.map((item: any) => {
                tempSelectedObj[item.SUB_DISPOSITION] = item.WATID
                tempSaveTemplateConfig.push({
                    "ORGANIZATION_ID": item.ORGANIZATION_ID,
                    "WATID": item.WATID,
                    "DISPOSITION": item.DISPOSITION,
                    "SUB_DISPOSITION": item.SUB_DISPOSITION,
                    "ISACTIVE": item.ISACTIVE
                })
                tempActiveDispositionObj[item.SUB_DISPOSITION] = item.ISACTIVE == "Y" ? true : false;
            })

            setSelectedTemplateMap(tempSelectedObj);
            setSaveTemplateConfig(tempSaveTemplateConfig);
            setActiveDispositionMap(tempActiveDispositionObj);
        }
    }, [orgConfigTemplates])

    const handleRadioChange = (activeTab: string | number, selectedSubDisposition: string, template: any, organization_id: string) => {
        setShowSubmitButton(true);
        // console.log("saveshjshjs 22",activeTab,selectedSubDisposition,template,organization_id)
        let tempSelectedObj = {
            ...selectedTemplateMap,
            [selectedSubDisposition]: template.WATID,
        }
        let tempSaveTemplateConfig = [
            ...saveTemplateConfig
        ];
        tempSaveTemplateConfig.forEach((item,index)=>{
            if(item["DISPOSITION"] == activeTab && item["SUB_DISPOSITION"] == selectedSubDisposition){
                tempSaveTemplateConfig.splice(index,1);
            }
        })
        tempSaveTemplateConfig.push({
            "ORGANIZATION_ID": organizationId,
            "WATID": template["WATID"],
            "DISPOSITION": activeTab,
            "SUB_DISPOSITION": selectedSubDisposition,
            "ISACTIVE": activeDispositionMap[selectedSubDisposition] ? "Y" : "N"
        })
        setSelectedTemplateMap(tempSelectedObj);
        setSaveTemplateConfig(tempSaveTemplateConfig);
    };

    // useEffect(()=>{
    //     console.log("saveshjshjs",saveTemplateConfig)
    // },[saveTemplateConfig])

    
    const handleToggle = (selectedSubDisposition:string,active:boolean) => {
        setShowSubmitButton(true);
        // console.log("seskakak",selectedSubDisposition,active);
        let tempSelectedObj = {
            ...activeDispositionMap,
            [selectedSubDisposition]: active,
        }
        let tempSaveTemplateConfig = [
            ...saveTemplateConfig
        ];
        tempSaveTemplateConfig.forEach((item,index)=>{
            if(item["SUB_DISPOSITION"] == selectedSubDisposition){
                item["ISACTIVE"] = active ? "Y" : "N"
            }
        })
        setSaveTemplateConfig(tempSaveTemplateConfig);
        setActiveDispositionMap(tempSelectedObj);
    };

    const browseDispositionTemplate = async (selectedTab: any) => {
        try {
            const templates:any = await fetchDispositionTemplates(selectedTab, selectedTemplatesType, page, pageSize, setTotalCount);
            setDispositionTemplates(templates || []);
        } catch (error) {
            setDispositionTemplates([]);
            // console.error("Error fetching disposition templates:", error);
        }

        // const subDispositionsListArray = [];
        // for (let key in browseTemplateData) {
        //     subDispositionsListArray.push(key);
        // }
        // setSubDispositionsList(subDispositionsListArray);
    }

    useEffect(() => {
        browseDispositionTemplate(activeTab);
    }, [activeTab, page, pageSize])

    useEffect(() => {
        if (selectedTemplatesType === "Disposition based") {
            setActiveTab("Call Back");
        } else {
            setActiveTab("Pre Launch");
        }
    }, [selectedTemplatesType])

    const DispositionTemplates: FunctionComponent<{ title: string, templates: string[] }> = ({ title, templates }) => {
        return (
            <div style={{ marginBottom: "1rem" }}>
                <div style={{display:"flex",alignItems:"center",gap:"1rem", marginBottom: "1rem"}}>
                    <div className={styles.whatsappPreviewMessagesContainer} onClick={() => {
                       (selectedSubDisposition === title) ? setSelectedSubDisposition("") : setSelectedSubDisposition(title)
                    }}>
                        {(selectedSubDisposition === title) ? <ExpandMoreIcon /> : <NavigateNextIcon />}
                        <p>{title}</p>
                    </div>
                    {
                        selectedTemplatesType === "Disposition based" && (
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                {/* <p>On</p> */}
                                <ToggleButton
                                    checked={activeDispositionMap[title]}
                                    onChange={(e: any) => {
                                        // console.log("alala",e.target.value)
                                        // freezeApproval(!freezeScreenApprove)
                                        handleToggle(title, !activeDispositionMap[title]);
                                    }}
                                    id={uuidv4()}
                                    customStyles={{ backgroundColor: activeDispositionMap[title] ? "#269f9f" : "#e8e8e8", border: activeDispositionMap[title] ? "none" : "2px solid #d7d7d7" }}
                                />
                            </div>
                        )
                    }
                </div>
                {(selectedSubDisposition === title) && (
                    <div className={styles.whatsappPreviewMessages}>
                        {templates.length > 0 ? templates.map((value: any, index: any) => {
                            // console.log("testdgdgdg",value)
                            return (
                                <WhatsappMessagePreview
                                    selected={selectedTemplateMap[selectedSubDisposition]}
                                    handleChange={()=>{
                                        handleRadioChange(activeTab,selectedSubDisposition,value,organizationId);
                                    }}
                                    templateTitle={`Template ${index+1}`}
                                    // templateTitle={value.TEMPLATE_NAME}
                                    id={value.WATID || value.OTID}
                                    // children={<DispositionWhatsappTemplate1 msgContent={value?.MSG_CONTENT} />}
                                    children={<DispositionWhatsappTemplate1 msgContent={value.MSG_PREVIEW ? value.MSG_PREVIEW : replacePlaceholders(value.MSG_CONTENT, value.PLACEHOLDER_HEADERS)}  />}
                                    selectedTemplatesType={selectedTemplatesType}
                                    templateData={value}
                                    setShowDownload={setShowDownload}
                                    showDownload={showDownload}
                                />
                            );
                        }):<p>No Templates Available</p>}
                    </div>
                )}
            </div>
        );
    };


    return (
        <>
            <div className={styles.dispositionTemplatesContainer}>
                <div className={styles.dispositionTabsContainer}>
                    {
                        selectedTemplatesType == "Disposition based" ?
                            whatsappSetupDispositionTabs?.map((tab, index) => {
                                return (
                                    <TabNavItem
                                        key={index}
                                        id={tab.id}
                                        title={tab.title}
                                        activeTab={activeTab}
                                        setActiveTab={setActiveTab}
                                        className={styles.tabContainer}
                                        activeClass={styles.tabContainerActive}
                                    />
                                )
                            })
                            :
                            whatsappSetupMakretingTabs?.map((tab, index) => {
                                return (
                                    <TabNavItem
                                        key={index}
                                        id={tab.id}
                                        title={tab.title}
                                        activeTab={activeTab}
                                        setActiveTab={setActiveTab}
                                        className={styles.tabContainer}
                                        activeClass={styles.tabContainerActive}
                                    />
                                )
                            })
                    }
                </div>
                <div className={styles.templatesContainer}>
                    <TabContent id={activeTab} activeTab={activeTab} className="tab-content">
                        {
                            dispositionTemplates?.map((item: any, index: any) => {
                                let keyName = Object.keys(item);
                                const templates = item[keyName[0]]?.value || [];
                                return <DispositionTemplates title={keyName[0]} templates={templates} />;
                            })
                        }

                    </TabContent>
                    {selectedTemplatesType === 'Broadcast Message' && (
                        <PaginationFooter
                            page={page}
                            setPage={setPage}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalCount={totalCount}
                            isLastPage={isLastPage}
                            pageSizeOptions={[5,10,25]}
                        />
                    )}
                </div>
                {
                    showSubmitButton && (
                        <div className={styles.saveContainer}>
                            <div className={styles.saveSubContainer}>
                                {
                                    orgConfigTemplates ? <p>You need to save configuration after making any changes above .</p> : 
                                    <p>Note : Plan will only get activated once template setup is complete for each lead status.</p>
                                }
                                {
                                    orgConfigTemplates ? <button className={styles.saveButton} onClick={() => {
                                        updateOrgDispositionConfig(organizationId, saveTemplateConfig, dispatcher, history,setShowSubmitButton);
                                    }}>Apply Changes</button> :
                                        <button className={styles.saveButton} onClick={() => {
                                            createOrgDispositionConfig(organizationId, saveTemplateConfig, dispatcher, history,setShowSubmitButton);
                                        }}>Save & Submit</button>
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        organizationId: state.organization.id,
        constants: state.constants.data,
    };
};

export default connect(mapStateToProps)(DispositionWhatsappTemplates);